import { createAction, props } from '@ngrx/store';
import { Feed } from '../domain/feed';
import { DesignatedContentGroup } from './components/designated-content-group-dialog/designated-content-group-dialog.view-model';

const feature = '[Content group list]';

export const createContentGroup = createAction(`${feature} Create content group`, props<{ title: string; description?: string }>());
export const createContentGroupSuccess = createAction(`${feature} Create content group success`);
export const createContentGroupFail = createAction(`${feature} Create content group fail`, props<{ errorMessage: string }>());

export const loadScreen = createAction(
  `${feature} Load screen`,
  props<{ feeds?: Feed[]; contentGroups?: DesignatedContentGroup[]; searchTerm?: string }>()
);
export const loadScreenSuccess = createAction(
  `${feature} Load screen success`,
  props<{ feeds: Feed[]; contentGroups: DesignatedContentGroup[] }>()
);
export const loadScreenFail = createAction(`${feature} Load screen fail`, props<{ errorMessage: string }>());

export const updateDesignatedContentGroups = createAction(
  `${feature} Update designated content groups`,
  props<{ contentGroups: DesignatedContentGroup[] }>()
);
export const updateDesignatedContentGroupsSuccess = createAction(
  `${feature} Update designated content groups success`,
  props<{ contentGroups: DesignatedContentGroup[] }>()
);
export const updateDesignatedContentGroupsFail = createAction(
  `${feature} Update designated content groups fail`,
  props<{ errorMessage: string }>()
);
